import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MxButtonModel} from '../../mx-button/components/mx-button.model';

@Component({
    selector: 'mx-thumbnail-edit',
    standalone: false,
    templateUrl: './mx-thumbnail-edit.component.html'
})
export class MxThumbnailEditComponent implements OnInit {
    @Input() defaultThumbnailClass: string;
    @Input() thumbnailUrl: string;
    @Input() hasReset: boolean = true;
    @Output() upload: EventEmitter<void> = new EventEmitter();
    @Output() reset: EventEmitter<void> = new EventEmitter();

    uploadThumbBtn: MxButtonModel;
    resetThumbBtn: MxButtonModel;

    private uploadThumbnail = () => {
        this.upload.emit();
    }
    private resetThumbnail = () => {
        this.reset.emit();
    }

    ngOnInit(): void {
        this.uploadThumbBtn = {
            label: 'Upload Thumbnail',
            tooltip: 'Upload Thumbnail',
            className: 'mxs-button--primary',
            clickHandler: this.uploadThumbnail
        };
        this.resetThumbBtn = {
            label: 'Reset to Default',
            tooltip: 'Reset to Default',
            className: 'mxs-button--primary',
            clickHandler: this.resetThumbnail
        };
    }
}
